import { connect } from 'react-redux';

import get from 'lodash/get';

import ScrollIndicator from './scroll_indicator.jsx';

import {
  simulateMenuItemClick
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';

import { 
  getCurrentSubpage,
  getVisibleSubmenuItemsBySubpageId
} from 'zoomforth_codesbane_viewer/reducers/index.js';

const mapStateToProps = (state) => {
  const currentSubpage = getCurrentSubpage(state);
  const submenuItems = get(getVisibleSubmenuItemsBySubpageId(state), currentSubpage.id, []);

  return { submenuItems, currentSubpage };
};

const mapDispatchToProps = (dispatch) => ({
  onScrollToSubmenuItem: (currentSubpage, submenuItem)=> {
    dispatch(simulateMenuItemClick(submenuItem, currentSubpage, {}));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScrollIndicator);
